import React from 'react';

import starsBackgroundElbb from 'assets/img/2026/estrelas_elbb.png';
import logoElbb from 'assets/img/2026/logoELBB.png';
import seloEuParticipoElbb from 'assets/img/2026/ELBB/selo_eu_participo_elbb.png';

interface ParticipationConfirmedModalElbbProps {
  onClose: () => void;
}

export function ParticipationConfirmedModalElbb({ onClose }: ParticipationConfirmedModalElbbProps) {
  return (
    <div
      className="participation-confirmed-card relative w-full max-w-[430px] overflow-hidden rounded-[24px] bg-[#0BEADD] px-4 py-4 text-center md:px-5 md:py-5"
      style={{ backgroundImage: `url(${starsBackgroundElbb})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
    >
      <img src={logoElbb} alt="Logo ELBB" className="mx-auto mb-3 w-[74px] object-contain md:w-[86px]" />

      <h2 className="m-0 text-[1.75rem] font-bold leading-tight text-[#753BBD] md:text-[1.95rem]">Participação confirmada!</h2>

      <p className="mt-2 mb-0 text-[1.55rem] font-bold leading-[1.18] text-white md:text-[1.75rem]">
        Agora você faz parte do <span className="text-[#3333BD]">Prêmio ELBB</span> e já pode exibir com orgulho o seu selo{' '}
        <span className="text-[#753BBD]">“Eu participo”.</span>
      </p>

      <p className="mt-2 mb-0 text-[1rem] font-bold leading-[1.28] text-[#753BBD] md:text-[1.05rem]">
        Use o selo na sua foto de perfil, baixe para compartilhar e espalhe essa conquista!
      </p>

      <div className="relative mx-auto mt-3 h-[150px] w-[150px] md:h-[168px] md:w-[168px]">
        <img
          src={seloEuParticipoElbb}
          alt="Selo Eu participo ELBB"
          className="absolute left-1/2 top-1/2 w-[142px] -translate-x-1/2 -translate-y-1/2 object-contain md:w-[160px]"
        />
      </div>

      <a
        href={seloEuParticipoElbb}
        download="selo-eu-participo-elbb.png"
        className="mt-2 inline-block text-base font-semibold text-[#753BBD] underline md:text-lg"
      >
        Baixar selo
      </a>

      <div className="mt-3">
        <button
          type="button"
          onClick={onClose}
          className="rounded-lg border-0 bg-pink-bb-2 px-5 py-2 text-sm font-extrabold text-white md:text-base"
        >
          Fechar
        </button>
      </div>
    </div>
  );
}
